import type { ManagerClientDetail } from '@expeditor/shared';
import { ClientFieldsByType } from '../../shared/ui/ClientFieldsByType';

interface Props {
  client: ManagerClientDetail;
}

/** Тонкая обёртка над {@link ClientFieldsByType} для manager-view. */
export function ClientIdentificationDetails({ client }: Props) {
  return (
    <ClientFieldsByType
      type={client.type}
      fields={client.details as Record<string, unknown> | null}
      contact={{
        phone: client.phone,
        email: client.email,
        actualAddress: client.actualAddress,
      }}
    />
  );
}
